import React, { useState, useEffect } from 'react';
import { Input, Select } from 'antd'
import moment from 'moment';
import APIClient from '../../services/APIClient';
import JSONInput from "react-json-ide";
import locale from "react-json-ide/locale/en";

import ReactJsonViewer from 'app/lib/utils/ReactJsonViewer';
import { makeApiCall } from 'app/admin/services/ApiService';

const { Option } = Select;
// name, dateUpdated, dateLastRun, filter, project, sort
export const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
        shouldUseAsfilter: true,
    },
    {
        title: 'Date Updated',
        dataIndex: 'dateUpdated',
        key: 'dateUpdated',
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
        sorter: (a, b) => a?.dateUpdated?.localeCompare(b?.dateUpdated),
        shouldUseAsfilter: false,
    },
    {
        title: 'Date Last Run',
        dataIndex: 'dateLastRun',
        key: 'dateLastRun',
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
        sorter: (a, b) => a?.dateLastRun?.localeCompare(b?.dateLastRun),
        shouldUseAsfilter: false
    },
    {
        title: 'Filter',
        dataIndex: 'filter',
        key: 'filter',
        render: (filter = {}) => (
            <div className="data-item">
                <ReactJsonViewer style={{ minWidth: "250px", maxWidth: "500px" }} src={{ filter }} collapsed={true} />
            </div>
        ),
        shouldUseAsfilter: false
    },
    {
        title: 'Project',
        dataIndex: 'project',
        key: 'project',
        render: (project = {}) => (
            <div className="project-item">
                <ReactJsonViewer style={{ minWidth: "250px", maxWidth: "500px" }} src={{ project }} collapsed={true} />
            </div>
        ),
        shouldUseAsfilter: false
    },
    {
        title: 'Sort',
        dataIndex: 'sort',
        key: 'sort',
        render: (sort = {}) => (
            <div className="data-item">
                <ReactJsonViewer style={{ minWidth: "250px", maxWidth: "500px" }} src={{ sort }} collapsed={true} />
            </div>
        ),
        shouldUseAsfilter: false
    }
];


export const formSchema = [
    {
        props: {
            name: "name",
            label: "Name"
        },
        component: Input
    },
    {
        props: {
            name: "collection",
            label: "DB Collection"
        },
        component: (props) => {
            const [collections, setCollections] = useState([]);

            const getCollections = async () => {
                const fetchCollections = await makeApiCall({
                    startCallMessage: 'API: Creating Mongo Query Data',
                    successMessage: 'API: Successfully created Mongo Query Data',
                    failureMessage: 'API: Creating Mongo Query Failed',
                    url: '/admin/mongo-queries/collections',
                    method: APIClient.get,
                    data: null,
                    config: null,
                    shouldShowNotifications: false,
                    extractPath: (data) => data.collections,
                })
                setCollections(fetchCollections);
            }

            useEffect(() => {
                getCollections()
            }, [])

            return (
                <Select value={props.value} onChange={props.onChange} style={{ width: '100%' }}>
                    {collections.map((key) => <Option value={key}>{key}</Option>)}
                </Select>
            )
        },
    },
    {
        props: {
            name: "method",
            label: "Operation Type"
        },
        component: (props) => {
            return (
                <Select value={props.value} onChange={props.onChange} style={{ width: '100%' }}>
                    <Option value={"find"}>find</Option>
                    <Option value={"aggregate"}>aggregate</Option>
                    <Option value={"updateMany"}>updateMany</Option>
                    <Option value={"deleteMany"}>deleteMany</Option>
                </Select>
            )
        },
    },
    {
        props: {
            name: "filter",
            label: "Filter"
        },
        component: (props) => {
            return (
                <div style={{ textAlign: "left" }}>
                    <JSONInput
                        onChange={({ error, jsObject }) => {
                            if (!error)
                                props.onChange(jsObject);
                        }}
                        placeholder={props.value || {}}
                        locale={locale}
                        colors={{
                            background: "#F9FAFA",
                            default: "#6C7778",
                            keys: "#232F3E",
                            colon: "#6C7778"
                        }}
                        height="100px"
                        width="900px"
                    />
                </div>
            )
        },
    },
    {
        props: {
            name: "projects",
            label: "Projects"
        },
        component: (props) => {
            return (
                <div style={{ textAlign: "left" }}>
                    <JSONInput
                        onChange={({ error, jsObject }) => {
                            if (!error)
                                props.onChange(jsObject);
                        }}
                        placeholder={props.value || {}}
                        locale={locale}
                        colors={{
                            background: "#F9FAFA",
                            default: "#6C7778",
                            keys: "#232F3E",
                            colon: "#6C7778"
                        }}
                        height="100px"
                        width="900px"
                    />
                </div>
            )
        },

    },
    {
        props: {
            name: "sort",
            label: "Sort"
        },
        component: (props) => {
            return (
                <div style={{ textAlign: "left" }}>
                    <JSONInput
                        onChange={({ error, jsObject }) => {
                            if (!error)
                                props.onChange(jsObject);
                        }}
                        placeholder={props.value || {}}
                        locale={locale}
                        colors={{
                            background: "#F9FAFA",
                            default: "#6C7778",
                            keys: "#232F3E",
                            colon: "#6C7778"
                        }}
                        height="100px"
                        width="900px"
                    />
                </div>
            )
        },
    }
]
